import { render, staticRenderFns } from "./CardReporteFirmas.vue?vue&type=template&id=5214b444"
import script from "./CardReporteFirmas.vue?vue&type=script&lang=js"
export * from "./CardReporteFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports